/**
 * AgentConversationListHeader
 *
 * Header for conversation list view with search and master checkbox (Gmail pattern)
 */

import React, { useRef, useEffect } from 'react';

const AgentConversationListHeader = ({
  filterType = 'all',
  conversationCount = 0,
  searchValue = '',
  onSearchChange = () => {},
  selectedCount = 0,
  onSelectAll = () => {},
  onDeselectAll = () => {},
  allSelected = false
}) => {
  const searchInputRef = useRef(null);

  // Auto-focus the search input when component mounts
  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  const getTitle = () => {
    switch (filterType) {
      case 'favorites':
        return 'Favorite Conversations';
      case 'archived':
        return 'Archived Conversations';
      default:
        return 'All Conversations';
    }
  };

  const handleSearchChange = (e) => {
    onSearchChange(e.target.value);
  };

  const handleClearSearch = () => {
    onSearchChange('');
  };

  const handleMasterCheckboxClick = () => {
    if (allSelected || selectedCount > 0) {
      onDeselectAll();
    } else {
      onSelectAll();
    }
  };

  return (
    <div className="agent-conversation-list-header">
      <div className="agent-conversation-list-header-top">
        <div className="agent-conversation-list-header-left">
          {/* Master checkbox for select all (Gmail pattern) */}
          <div className="agent-conversation-list-master-checkbox">
            <input
              type="checkbox"
              checked={allSelected}
              ref={(input) => {
                if (input) {
                  input.indeterminate = selectedCount > 0 && !allSelected;
                }
              }}
              onChange={handleMasterCheckboxClick}
              aria-label={allSelected ? 'Deselect all' : 'Select all'}
            />
          </div>
          <h1 className="agent-conversation-list-title">{getTitle()}</h1>
        </div>
        <div className="agent-conversation-list-count">
          {conversationCount} {conversationCount === 1 ? 'conversation' : 'conversations'}
        </div>
      </div>

      <div className="agent-conversation-list-search">
        <input
          ref={searchInputRef}
          type="text"
          className="agent-conversation-list-search-input"
          placeholder="Search conversations..."
          value={searchValue}
          onChange={handleSearchChange}
        />
        {searchValue && (
          <button
            className="agent-conversation-list-search-clear"
            onClick={handleClearSearch}
            aria-label="Clear search"
            type="button"
          >
          </button>
        )}
      </div>
    </div>
  );
};

export default AgentConversationListHeader;
